import { Box } from 'components'
import { getSpacing } from 'utils'
import { InfoItem } from './InfoItem'

export interface ITopInfoSectionProps {
  isMobile?: boolean
  items: {
    label: string
    value: string
    tooltip?: string
  }[]
}

export const InfoItemsBundle = ({ isMobile, items }: ITopInfoSectionProps) => {
  if (isMobile) {
    return (
      <>
        {items.map((item, i) => (
          <Box key={i} marginTop={i > 0 && getSpacing('s')}>
            <InfoItem singleLine={isMobile} {...item} />
          </Box>
        ))}
      </>
    )
  } else {
    return (
      <Box flexDirection="row" display="flex" justifyContent="space-between">
        {items.map((item, i) => (
          <Box
            key={i}
            paddingLeft={(i === 1 && '4%') || (i === 0 && '4%')}
            paddingRight={(i === 1 && '4%') || (i === 2 && '4%')}
            style={{
              borderLeft: i === 1 && '1px solid rgba(152, 149, 161, 0.5)',
              borderRight: i === 1 && '1px solid rgba(152, 149, 161, 0.5)',
            }}
          >
            <InfoItem {...item} />
            {i < items.length - 1 && (
              <Box width="1px" backgroundColor="TEXT_DARK" style={{ opacity: 0.5 }} />
            )}
          </Box>
        ))}
      </Box>
    )
  }
}
